import { render, staticRenderFns } from "./PdfViewer.vue?vue&type=template&id=5a9e95c4&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"
import style0 from "./PdfViewer.vue?vue&type=style&index=0&id=5a9e95c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9e95c4",
  null
  
)

export default component.exports